import React, { createContext, useContext } from 'react';

import { AGGREGATION_TYPE } from 'components/View/constants';
import { createDefaultDataQuarterSelection } from 'components/View/filters/DataQuarterFilter/helpers';
import { DISPLAY_VALUES, ORIENTATION_TYPE } from 'constants/charts';

import { DATA_DISPLAY_TYPE, DATA_RANGE_TYPE, PRICE_DISPLAY_TYPE } from './constants';
import { COMMUNITY_CONTRACT_SELECTION_TYPE } from '../../../constants';
import { WidgetFilterType, WidgetGrouping } from '../types';

type WidgetContent = {
  id?: number;
  type: number;
  name: string;
  note: string;
  filters: WidgetFilterType;
  isModalPreview?: boolean;
  meta: any;
  elementRef: any;
  rangeType: string;
  displayType: string;
  orientationType: string;
  filename: string;
  csvData: any;
  initialRange?: string;
  initialFormat?: string;
  initialOrientation?: string;
  displayValue?: number;
  priceDisplay: number;
  groupBy?: WidgetGrouping;
  showRemoveWidgetModal: boolean;
  showEditWidgetModal: boolean;
  setMeta: (obj: any) => void;
  setRangeType: (range: string) => void;
  setDisplayType: (display: string) => void;
  setOrientationType: (display: string) => void;
  setDisplayValue: (value: number) => void;
  setPriceDisplay: (priceDisplay: number) => void;
  setGroupBy: (groupBy?: WidgetGrouping) => void;
  setFilename: (display: string) => void;
  setCSVData: (data: any[]) => void;
  setShowRemoveWidgetModal: (show: boolean) => void;
  setShowEditWidgetModal: (show: boolean) => void;
};

export const WidgetContext = createContext<WidgetContent>({
  id: 0,
  type: 0,
  name: '',
  note: '',
  isModalPreview: false,
  filters: {
    competitors: [],
    careTypes: [],
    roomTypes: [],
    roomTypesPriceDisplay: AGGREGATION_TYPE.AVG,
    careLevels: [],
    medicationLevels: [],
    reviewSources: [],
    reviewCategories: [],
    swotCategories: [],
    amenityCategories: [],
    contractTypes: [],
    careLevelsStatsType: AGGREGATION_TYPE.AVG,
    medicationLevelsStatsType: AGGREGATION_TYPE.AVG,
    dataQuarterSelection: createDefaultDataQuarterSelection(),
    comparisonTypeEnabled: false,
    valueDisplay: 0,
    communityContractType: undefined,
    communityContractSelectionType: COMMUNITY_CONTRACT_SELECTION_TYPE.APPROXIMATE,
    communityContractSlugs: [],
  },
  meta: undefined,
  elementRef: undefined,
  rangeType: '',
  displayType: '',
  orientationType: '',
  filename: '',
  csvData: [],
  initialRange: DATA_RANGE_TYPE.NOW,
  initialFormat: DATA_DISPLAY_TYPE.GRAPH,
  initialOrientation: ORIENTATION_TYPE.HORIZONTAL,
  displayValue: DISPLAY_VALUES.DISPLAY.value,
  priceDisplay: PRICE_DISPLAY_TYPE.SINGLE,
  groupBy: undefined,
  showRemoveWidgetModal: false,
  showEditWidgetModal: false,
  setMeta: () => {
    //  Do Nothing
  },
  setRangeType: () => {
    //  Do Nothing
  },
  setDisplayType: () => {
    //  Do Nothing
  },
  setOrientationType: () => {
    //  Do Nothing
  },
  setPriceDisplay: (priceDisplay: number) => {
    //  Do Nothing
  },
  setGroupBy: () => {
    //  Do Nothing
  },
  setDisplayValue: () => {
    //  Do Nothing
  },
  setFilename: () => {
    //  Do Nothing
  },
  setCSVData: () => {
    //  Do Nothing
  },
  setShowRemoveWidgetModal: () => {
    //  Do Nothing
  },
  setShowEditWidgetModal: () => {
    //  Do Nothing
  },
});

export const useWidgetContext = () => useContext(WidgetContext);
